import { USER_ROLES } from "../constants/appConstants";
import { userApiService } from "./userApiService";

function normalizeRole(role) {
  const r = String(role || "").toLowerCase().trim();
  if (r === "superadmin" || r === "super_admin") return USER_ROLES.SUPER_ADMIN;
  if (r === "admin") return USER_ROLES.ADMIN;
  if (r === "operator") return USER_ROLES.OPERATOR;
  return USER_ROLES.VIEWER;
}

export async function getUserRole(uid) {
  for (let attempt = 0; attempt < 2; attempt += 1) {
    try {
      const data = await userApiService.getProfile();
      return normalizeRole(data?.item?.role);
    } catch {
      if (attempt === 0) {
        await new Promise((resolve) => setTimeout(resolve, 600));
        continue;
      }
      return null;
    }
  }
  return null;
}

